import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatMenu, MatMenuModule } from '@angular/material/menu';
import { Crossmatch } from '../../../interfaces/crossmatch';
import { NgModel } from '@angular/forms';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'app-rowmenu',
    imports: [MatIconModule, MatMenu, CommonModule, MatMenuModule],
    templateUrl: './rowmenu.component.html',
    styleUrl: './rowmenu.component.scss'
})
export class RowmenuComponent {
  @Input() comb!: Crossmatch;
  @Output() action: EventEmitter<{ event: string; param: Crossmatch }>;

  constructor() {
    this.action = new EventEmitter();
  }

  async delete() {
    const event = { event: 'delete', param: this.comb };
    this.action.emit(event);
  }
}
